import { z } from "zod";

import { ROLE_PAYLOAD_MAP } from "./payloadMappings";

const requiredString = (message) => z.string().min(1, { message });
const ratingSchema = requiredString("Rating is required");

// Deprecated: kept for backward compat if any direct import usage exists
// BUT we strictly prefer the dynamic one.
// We'll export the dynamic one.

export const getValidationSchema = (role) => {

    // Base validation rules common to all roles
    // Moved inside to support dynamic field requirements
    const baseSchema = {
        employeeId: z.string().optional(),
        employeeName: requiredString("Employee Name is required"),
        jobTitle: z.string().optional(),
        evaluationDate: requiredString("Evaluation Date is required"),
        reviewType: z.string().optional(),
        hireDate: z.string().optional(),

        // Comments
        dutiesCommentPage1: z.string().optional(),
        dutiesCommentPage2: z.string().optional(),
        dutiesCommentPage3: z.string().optional(), // Added Page 3 for HHA/RN checks
        overallComments: z.string().optional(),
        targetedGoals: z.string().optional(),
        targetedGoalsPage1: z.string().optional(),
        targetedGoalsPage2: z.string().optional(),
        targetedGoalsPage3: z.string().optional(),

        // Signatures
        reviewerName: requiredString("Reviewer name is required"),
        reviewerSignature: requiredString("Reviewer signature is required"),
        reviewerSignedAt: requiredString("Reviewer signed at is required"),
        reviewerSignatureImage: z.string().optional(),

        // Employee signature (optional for evaluations, but kept for schema compatibility)
        employeeSignature: z.string().optional(),
        employeeSignatureDate: z.string().optional(),

        // Common Tardy/Absent fields (generic coverage)
        daysTardy: z.string().optional(),
        daysAbsent: z.string().optional(),
        organizational2_daysTardy: z.string().optional(),
        organizational2_daysAbsent: z.string().optional(),
        organizational3_daysTardy: z.string().optional(),
        organizational3_daysAbsent: z.string().optional(),
    };

    // Start with base schema definition
    const schemaShape = { ...baseSchema };

    // 1. PT/PTA Handling (1-25)
    if (role === 'PT' || role === 'PTA' || !role) {
        for (let i = 1; i <= 25; i++) {
            schemaShape[`duty${i}`] = ratingSchema;
        }
        return z.object(schemaShape);
    }

    // 2. Other Roles (Use Mapping)
    const mapping = ROLE_PAYLOAD_MAP[role];
    if (mapping) {
        Object.keys(mapping).forEach(frontendId => {
            schemaShape[frontendId] = ratingSchema;
        });
    }

    // Add generic backup for duties just in case mapping misses something or for safety
    // (Optional, mostly relies on mapping)

    return z.object(schemaShape);
};
